import { render, staticRenderFns } from "./TheMultiCompanySearchTab.vue?vue&type=template&id=50a3c486"
import script from "./TheMultiCompanySearchTab.vue?vue&type=script&lang=js"
export * from "./TheMultiCompanySearchTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports